module.exports = __webpack_public_path__ + "img/27_83.86fe451e.png";